import { createContext } from 'react';
import { User, IdTokenResult, ParsedToken } from 'firebase/auth';

// Define UserRole enum to match frontend
enum UserRole {
  FLEET_MANAGER = 'fleetManager',
  TRADER = 'trader',
}

interface AuthContextType {
  user: User | null;
  currentUser: User | null;
  role: UserRole | null;
  loading: boolean;
  signIn: (email: string, password: string) => Promise<void>;
  signOut: () => Promise<void>;
  signUp: (email: string, password: string) => Promise<User>;
  getUser: () => User | null;
  isAdmin: () => Promise<boolean>;
  getIdTokenResult: () => Promise<IdTokenResult | undefined>;
  getClaims: () => Promise<ParsedToken | undefined>;
  adminAccessDenied: boolean;
  clearAdminAccessDenied: () => void;
  isAdminFlag: boolean; // synchronous flag
}

export const AuthContext = createContext<AuthContextType | null>(null);
